import Divider from "@material-ui/core/Divider";

const React = require('react');
import {Box} from "@material-ui/core";

import Caption from "../../../../dumb/Caption/B";
import Password from "./Password";
import Tfa from "./Tfa";

module.exports = () => (
  <>
    <Password />
    <Box mt="8rem" mb="4rem">
      <Divider />
    </Box>
    <Caption>
      Two Factor Auth
    </Caption>
    <div className="mt20">
      <Tfa />
    </div>
  </>
)
